import { ModelFactory } from '@shared/factories/model.factory';
import { PaymentTypeType } from '@generated/graphql';
import { PaymentType } from "@modules/payment/models/payment-type.model";

export class PaymentTypeFactory extends ModelFactory<PaymentTypeType, PaymentType> {
  create (state: PaymentTypeType): PaymentType {
    return new PaymentType(state);
  }
}

export const paymentTypeFactory = new PaymentTypeFactory();
